import { render } from "./UpdateScreen.vue?vue&type=template&id=4091aeda&scoped=true"
import script from "./UpdateScreen.vue?vue&type=script&lang=js"
export * from "./UpdateScreen.vue?vue&type=script&lang=js"

import "./UpdateScreen.vue?vue&type=style&index=0&id=4091aeda&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4091aeda"]])

export default __exports__